<style>
#variancesRegister .v--modal-box.v--modal {
  min-height: 440px !important;
  min-width: 685px !important;
}
#variancesRegister .modal__content {
  overflow-y: hidden !important;
}
#variancesRegister .modal__footer {
  display: none;
}
</style>

<template>
  <Modal
    modalName="variancesRegister"
    title="REJESTR ROZBIEŻNOŚCI"
    :buttons="[]"
    :register="register"
    @closed="close"
  >
    <VariancesTable />
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";
import VariancesTable from "../../../table/VariancesTable";

export default {
  components: {
    Modal,
    VariancesTable
  },
  data: () => ({
    register: true
  }),
  methods: {
    close() {
      this.$root.$emit("removeObjectArea");
    },
    removeObjectArea() {
      this.$root.$emit("removeObjectArea");
    },
    switchOn() {
      this.$root.$emit("drawVariances", true);
    },
    switchOff() {
      this.$root.$emit("drawVariances", false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/variances/VariancesRegister.vue